import { useEffect, useState } from 'react';
import axios from 'axios';
import { allowScroll, preventScroll } from '../../common/utils';

function MarketInfoModal(props) {
	const [MarketData, setMarketData] = useState({});

	useEffect(() => {
		setMarketData(props.data);
		const prevScrollY = preventScroll();
		return () => {
			allowScroll(prevScrollY); //컴포넌트가 언마운트되거나 업데이트될 때 이 함수가 실행
		};
	}, []);

	return (
		<div className='modal'>
			<div
				className='overlay'
				onClick={() => props.getMarketInfoModalOpen(false)}
			></div>
			<div className='modal-content'>
				<div className='modal-header'>
					<h2>작업 진행 내용 확인</h2>
				</div>
				<button
					className='close-modal'
					onClick={() => props.getMarketInfoModalOpen(false)}
				></button>
				<div className='modal-body'>
					<div className='modal-column'>
						<span className='key'>작업 진행</span>
						<span className='value'></span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default MarketInfoModal;
